export default "__VITE_ASSET__CF0SS_ox__"